module.exports = __webpack_public_path__ + "static/media/home_img1.b5a0b863.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_img1.png
// module id = 255
// module chunks = 14